<template>
<div>
  <div class="page-header">
    <div class="row">
      <div class="col-md-6">
        <h1>{{ title }}</h1>
      </div>
      <div class="col-md-5 col-md-offset-1 flex justify-end">
        <div class="text-right" v-if="voltar"><a class="btn btn-default" type="button" :href="getUrl()" @click.prevent="getVoltar">Voltar</a></div>
        <div class="text-right" v-if="titleNew">
          <router-link class="btn btn-success" :to="`${url}novo`">{{ titleNew }}</router-link>
        </div>
      </div>
    </div>
  </div>
  <br/>
</div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: ['title', 'titleNew', 'url', 'voltar', 'voltarUrl'],
  methods: {
    getUrl() {
      if(this.voltarUrl) {
        return this.voltarUrl
      } else {
        return 'javascript:history.back()'
      }
    },
    getVoltar() {
      if(this.voltarUrl) {
        return this.$router.push(this.voltarUrl)
      } else {
        return 'javascript:history.back()'
      }
    }
  },
}
</script>
